import { Injectable } from "@angular/core";
import { Sort } from "@angular/material/sort";
import { StatusPipe } from "../pipes/status.pipe";
import { services } from "../ts/courierRates";

@Injectable({
  providedIn: "root"
})
export class SortTableDataService {
  // sorting code;
  originalDataSource: object[];
  statusPipe = new StatusPipe();

  sortTableData(sort: Sort, dataSource: any) {
    const data = dataSource.data.slice();
    if (sort.direction === "") {
      dataSource.data = this.originalDataSource;
      return;
    }

    dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        //All Orders Table START
        case "orderNumber":
          return compareAlphanumeric(a?.orderNumber, b?.orderNumber, isAsc);

        case "orderDetails":
          return compareAlphanumeric(a?.orderNumber, b?.orderNumber, isAsc);

        case "customerDetails":
          return compareAlphanumeric(a?.fullName, b?.fullName, isAsc);

        case "shipmentDetails":
          return compareAlphanumeric(
            a?.shipping_info?.courier?.courier_service,
            b?.shipping_info?.courier?.courier_service,
            isAsc
          );

        case "origin":
          return compareAlphanumeric(
            a?.shipping_info?.pickup_address?.name,
            b?.shipping_info?.pickup_address?.name,
            isAsc
          );

        case "orderDate":
          return compare(a?.orderDate, b?.orderDate, isAsc);

        case "warehouse":
          return compareAlphanumeric(
            a?.shipping_info?.pickup_address?.name,
            b?.shipping_info?.pickup_address?.name,
            isAsc
          );

        case "name":
          return compare(
            a?.firstName ? a?.firstName?.toLowerCase() : a?.name?.toLowerCase(),
            b?.firstName ? b?.firstName?.toLowerCase() : b?.name?.toLowerCase(),
            isAsc
          );

        case "orderValue":
          return compare(a?.orderTotal, b?.orderTotal, isAsc);

        case "codAmount":
          return compare(a?.codTotal, b?.codTotal, isAsc);

        case "destination":
          return compare(a?.city?.toLowerCase(), b?.city?.toLowerCase(), isAsc);

        case "status":
          return compareAlphanumeric(
            this.statusPipe.transform(a?.status),
            this.statusPipe.transform(b?.status),
            isAsc
          );
        //All Orders Table END

        //Transactions Summary table START
        case "transOrderNumber":
          return compareAlphanumeric(
            a?.transaction_details?.orderNumber,
            b?.transaction_details?.orderNumber,
            isAsc
          );

        case "transactionDate":
          return compare(a?.createdAt, b?.createdAt, isAsc);

        case "description":
          return compare(
            a?.transaction_type?.toLowerCase(),
            b?.transaction_type?.toLowerCase(),
            isAsc
          );

        case "credit":
          return compare(
            a?.transaction_details?.amount,
            b?.transaction_details?.amount,
            isAsc
          );

        case "debit":
          return compare(
            a?.transaction_details?.amount,
            b?.transaction_details?.amount,
            isAsc
          );

        case "balance":
          return compare(a?.balance, b?.balance, isAsc);

        //Transactions Summary Table END

        //COD Remittance Table START
        case "remitOrderNumber":
          return compareAlphanumeric(a?.orderNumber, b?.orderNumber, isAsc);

        case "codRemittDate":
          return compare(
            a?.remittedToUser?.date,
            b?.remittedToUser?.date,
            isAsc
          );

        case "codRemitStatus":
          return compareAlphanumeric(
            this.statusPipe.transform(a?.status),
            this.statusPipe.transform(b?.status),
            isAsc
          );

        case "codRemitAmount":
          return compare(a?.collectable, b?.collectable, isAsc);

        case "remittedAmount":
          return compare(
            a?.remittedToUser?.amount,
            b?.remittedToUser?.amount,
            isAsc
          );
        //COD Remittance Table End

        //Email column of Sub User Table
        case "email":
          return compare(
            a?.email?.toLowerCase(),
            b?.email?.toLowerCase(),
            isAsc
          );
        /* **************************************************************** */

        //Rates Table of Shipping Module START
        case "area":
          return compare(
            a?.courierName?.toLowerCase(),
            b?.courierName?.toLowerCase(),
            isAsc
          );

        case "first":
          return compare(a?.first, b?.first, isAsc);

        case "additional":
          return compare(a?.after, b?.after, isAsc);
        //Rates Table of Shipping Module END

        //Warehouses Table of Shipping Module START
        case "warehouseName":
          return compare(
            a?.warehouseName?.toLowerCase(),
            b?.warehouseName?.toLowerCase(),
            isAsc
          );

        case "date":
          return compare(a?.createdAt, b?.createdAt, isAsc);
        //Warehouses Table of Shipping Module END

        //SKU Table of Shipping Module START
        case "sku":
          return compare(a?.sku?.toLowerCase(), b?.sku?.toLowerCase(), isAsc);

        case "hsn":
          return compareAlphanumeric(
            a?.hsn ? a?.hsn?.toString() : a?.hsn,
            b?.hsn ? b?.hsn?.toString() : b?.hsn,
            isAsc
          );

        case "productName":
          return compare(
            a?.productName?.toLowerCase(),
            b?.productName?.toLowerCase(),
            isAsc
          );
        //SKU Table of Shipping Module END

        //Box Table of Shipping Module START
        case "weight":
          return compare(a?.weight, b?.weight, isAsc);

        case "length":
          return compare(a?.length, b?.length, isAsc);

        case "breadth":
          return compare(a?.breadth, b?.breadth, isAsc);

        case "height":
          return compare(a?.height, b?.height, isAsc);
        //Box Table of Shipping Module END

        //Customer Response table START
        case "responseDate":
          return compare(a?.responses[0]?.date, b?.responses[0]?.date, isAsc);
        //Customer Response table END

        //Weight Discrepancy Table START
        case "raiseDate":
          return compare(a?.weightDesc?.created, b?.weightDesc?.created, isAsc);

        case "initialWeight":
          return compare(
            a?.weightDesc?.oldWeight,
            b?.weightDesc?.oldWeight,
            isAsc
          );

        case "initialShipping":
          return compare(
            a?.weightDesc?.oldCharge,
            b?.weightDesc?.oldCharge,
            isAsc
          );

        case "newWeight":
          return compare(
            a?.weightDesc?.newWeight,
            b?.weightDesc?.newWeight,
            isAsc
          );

        case "newCharge":
          return compare(
            a?.weightDesc?.newCharge,
            b?.weightDesc?.newCharge,
            isAsc
          );
        //Weight Discrepancy Table END

        //courier partner charges table starts
        case "companyName":
          return compare(
            a?.courierPartner
              ? a?.courierPartner?.toLowerCase()
              : a?.originAddress?.companyName?.toLowerCase(),
            b?.courierPartner
              ? b?.courierPartner?.toLowerCase()
              : b?.originAddress?.companyName?.toLowerCase(),
            isAsc
          );

        case "shippingCharge":
          return compare(a?.price?.price, b?.price?.price, isAsc);

        case "chargedWeight":
          return compare(
            a?.price?.weightCharged,
            b?.price?.weightCharged,
            isAsc
          );
        //courier partner charges table end

        //rate Calculator table starts
        case "courierName":
          return compare(
            a?.baseCourier.toLowerCase(),
            b?.baseCourier.toLowerCase(),
            isAsc
          );

        case "courierService":
          return compare(
            a?.price?.courierObj?.service.toLowerCase(),
            b?.price?.courierObj?.service.toLowerCase(),
            isAsc
          );

        case "zone":
          return compare(
            a?.price?.zone?.zone.toLowerCase(),
            b?.price?.zone?.zone.toLowerCase(),
            isAsc
          );

        case "price":
          return compare(a?.price?.price, b?.price?.price, isAsc);

        case "tat":
          return compare(
            a?.price?.tat?.transitTime,
            b?.price?.tat?.transitTime,
            isAsc
          );
        //rate Calculator table end

        default:
          return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function compareAlphanumeric(
  a: string | number,
  b: string | number,
  isAsc: boolean
) {
  let result: number;

  // a or b is not defined
  if (!a) return 1;
  if (!b) return -1;

  // a or b is number
  if (typeof a === "number") {
    a = a.toString();
  }
  if (typeof b === "number") {
    b = b.toString();
  }

  result = a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: "base"
  });

  return result * (isAsc ? 1 : -1);
}
